import React, {memo} from 'react';
import {Grid} from "@material-ui/core";
import Router from "../Router";
import {makeStyles} from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'flex-start',
        maxWidth: '100%',
        maxHeight: '100%',
        background: theme.background,
        backgroundSize: 'cover',
        backgroundPosition: 'bottom'
    },
    bottom: {
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        borderTop: '1px solid rgba(0,0,0,0.08)',
        flexDirection: 'column',
        maxHeight: 120,
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
            alignSelf: 'flex-end',
            width: '100%',
            maxHeight: 80
        }
    },
    primary: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'flex-end',
    },
    content: {
        flex: 1,
        overflow: 'auto',
        maxHeight: 'calc(100vh - 184px)',
        [theme.breakpoints.up('sm')]: {
            maxHeight: 'calc(100vh - 144px)',
        },
        position: 'relative',
    },
}));


function Home() {
    const classes = useStyles();
    return (
        <Grid className={classes.root}>
            <Grid xs={12} item className={classes.primary}>
                <Grid className={classes.content}>
                    <Router/>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default memo(Home);
